"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_CONNECTION_STATUS = void 0;
exports["default"] = updateConnectionStatus;
var UPDATE_CONNECTION_STATUS = 'DIRECT_LINE/UPDATE_CONNECTION_STATUS';
exports.UPDATE_CONNECTION_STATUS = UPDATE_CONNECTION_STATUS;

function updateConnectionStatus(connectionStatus) {
  return {
    type: UPDATE_CONNECTION_STATUS,
    payload: {
      connectionStatus: connectionStatus
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJVUERBVEVfQ09OTkVDVElPTl9TVEFUVVMiLCJ1cGRhdGVDb25uZWN0aW9uU3RhdHVzIiwiY29ubmVjdGlvblN0YXR1cyIsInR5cGUiLCJwYXlsb2FkIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FjdGlvbnMvdXBkYXRlQ29ubmVjdGlvblN0YXR1cy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBVUERBVEVfQ09OTkVDVElPTl9TVEFUVVMgPSAnRElSRUNUX0xJTkUvVVBEQVRFX0NPTk5FQ1RJT05fU1RBVFVTJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXBkYXRlQ29ubmVjdGlvblN0YXR1cyhjb25uZWN0aW9uU3RhdHVzKSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogVVBEQVRFX0NPTk5FQ1RJT05fU1RBVFVTLFxuICAgIHBheWxvYWQ6IHsgY29ubmVjdGlvblN0YXR1cyB9XG4gIH07XG59XG5cbmV4cG9ydCB7IFVQREFURV9DT05ORUNUSU9OX1NUQVRVUyB9O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUEsSUFBTUEsd0JBQXdCLEdBQUcsc0NBQWpDOzs7QUFFZSxTQUFTQyxzQkFBVCxDQUFnQ0MsZ0JBQWhDLEVBQWtEO0VBQy9ELE9BQU87SUFDTEMsSUFBSSxFQUFFSCx3QkFERDtJQUVMSSxPQUFPLEVBQUU7TUFBRUYsZ0JBQWdCLEVBQWhCQTtJQUFGO0VBRkosQ0FBUDtBQUlEIn0=